import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Spin, Icon} from 'antd'

import style from './table.sass'

const antIcon = <Icon type="loading" style={{fontSize:12, color:'#fff', position:'absolute', top:0, left:0}} spin />

class Table extends Component {
  render() {
    const {currentPlanID, upgrade, loading} = this.props
    return(
      <section styleName='wrapper'>
        <div className='landing-container' styleName='container'>
          <table>
            <thead>
              <tr>
                <td></td>
                <td><img src='/img/landing/pricing/table-icon-1.png' alt=''/> Lite</td>
                <td><img src='/img/landing/pricing/table-icon-2.png' alt=''/> Professional</td>
                <td><img src='/img/landing/pricing/table-icon-3.png' alt=''/> Premium</td>
                <td><img src='/img/landing/pricing/table-icon-4.png' alt=''/> Enterprise</td>
              </tr>
              <tr>
                <th styleName='price-heading'>Pricing<br/> Plans</th>
                <th>Free</th>
                <th>$29 <span>Monthly</span></th>
                <th>$69 <span>Monthly</span></th>
                <th>Custom</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td><span>Algorithms</span></td>
                <td>2</td>
                <td>10</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td><span>Screeners</span></td>
                <td>1</td>
                <td>5</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td><span>Paper Trading</span></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
              </tr>
              <tr>
                <td><span>Securities</span></td>
                <td>Stocks</td>
                <td>Stocks, CryptoCurrency</td>
                <td>Stocks, CryptoCurrency</td>
                <td>Stocks, CryptoCurrency</td>
              </tr>
              <tr>
                <td><span>Trigger Notification</span></td>
                <td>Email</td>
                <td>Email</td>
                <td>Email, SMS</td>
                <td>Custom</td>
              </tr>
              <tr>
                <td><span>Backtest Period</span></td>
                <td>1 year</td>
                <td>5 year or more</td>
                <td>5 year or more</td>
                <td>5 year or more</td>
              </tr>
              <tr>
                <td><span>Data Stream</span></td>
                <td>Daily</td>
                <td>Daily</td>
                <td>Intraday</td>
                <td>Intraday</td>
              </tr>
              <tr>
                <td><span>Connect Live Broker</span></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
                <td><img src='/img/landing/pricing/tick-table.png' alt=''/></td>
              </tr>
              <tr>
                <td><span>Market Sentiment data</span></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td>Yes, additional cost</td>
                <td>Yes, additional cost</td>
                <td>Yes</td>
              </tr>
              <tr>
                <td><span>Custom Hosting</span></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td><img src='/img/landing/pricing/cross.png' alt=''/></td>
                <td>Dedicated virtual<br/> machine additional cost</td>
                <td>Self-hosting<br/> Available</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>{currentPlanID < 2 && <button type='button' onClick={() => upgrade(2)}>
                  {loading ? <Spin indicator={antIcon} size='small'/> : 'Upgrade'}
                </button>}</td>
                <td>{currentPlanID < 3 && <button type='button' onClick={() => upgrade(3)}>
                  {loading ? <Spin indicator={antIcon} size='small'/> : 'Upgrade'}
                </button>}</td>
                <td>{currentPlanID < 4 && <Link to='/contact'>
                  <button type='button'>Contact Us</button>
                </Link>}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    )
  }
}

export default Table
